<template>
  <!-- <div id="header">
  <headerComponent />
</div> -->
  <div >
    <router-view />
  </div>
  <!-- <div id="footer">
  <footerComponet />
</div> -->
</template>

<script>
// import headerComponent from "@/components/headerComponent.vue";
// import footerComponet from "@/components/footerComponet.vue";
export default {
   components: {
      // headerComponent,
      // footerComponet
      },
  name: "App",
  data() {
    return {
    };
  },
};
</script>

<style>
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-thumb {
  background: lightgray;
  border-radius: 5px;
}
</style>
